<template>
  <div class="top-section">
<!--    <div class="welcome-panel">
      <div class="welcome-illustration">
        <img src="https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png" alt="welcome" />
      </div>
      <div class="welcome-copy">
        <p class="welcome-greeting">您好，{{ userInfo.nick_name || '调度员' }}</p>
        <h3 class="welcome-title">调度工作台</h3>
        <p class="welcome-subtitle">狭路相逢勇者胜，愿您今日一切顺利！</p>
      </div>
    </div> -->
    <div class="stats-container">
      <div class="stat-card is-total">
        <div class="stat-icon"><i class="el-icon-suitcase"></i></div>
        <div class="stat-meta">
          <span class="stat-value">{{ planStatistic.totalPlans || 0 }}</span>
          <span class="stat-title">今日计划数</span>
        </div>
      </div>
      <div class="stat-card is-finished">
        <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
        <div class="stat-meta">
          <span class="stat-value">{{ planStatistic.completedPlans || 0 }}</span>
          <span class="stat-title">今日已完成</span>
        </div>
      </div>
      <div class="stat-card is-processing">
        <div class="stat-icon"><i class="el-icon-time"></i></div>
        <div class="stat-meta">

          <span class="stat-value">{{ planStatistic.inProgressPlans || 0 }}</span>
          <span class="stat-title">今日进行中</span>
        </div>
      </div>
      <div class="stat-card is-outbound">
        <div class="stat-icon"><i class="el-icon-upload2"></i></div>
        <div class="stat-meta">

          <span class="stat-value">{{ planStatistic.totalOutWeight || 0 }}</span>
          <span class="stat-title">今日出库吨数</span>
        </div>
      </div>
      <div class="stat-card is-inbound">
        <div class="stat-icon"><i class="el-icon-download"></i></div>
        <div class="stat-meta">

          <span class="stat-value">{{ planStatistic.totalInWeight || 0 }}</span>
          <span class="stat-title">今日入库吨数</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  inject: ["_parentThis"],
  data () {
    return {
      userInfo: {}
    };
  },
  computed: {
    planStatistic () {
      return {
        ...this._parentThis.planStatistic
      };
    },
  },
  methods: {
  },
  mounted () {
    const { userInfo } = this.$store.getters
    this.userInfo = userInfo

  }
};
</script>
<style lang="scss" scoped>
/* 顶部区域 */
.top-section {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 18px;
  margin-bottom: 12px;
  min-height: 120px;
}

.welcome-panel {
  flex: 1;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #3352ff 0%, #5c7dff 100%);
  border-radius: 14px;
  padding: 24px 28px;
  color: #fff;
  box-shadow: 0 12px 30px -18px rgba(37, 68, 255, 0.6);

  .welcome-illustration {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    img {
      width: 52px;
      height: 52px;
    }
  }

  .welcome-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .welcome-greeting {
    font-size: 14px;
    opacity: 0.85;
    margin: 0;
  }

  .welcome-title {
    font-size: 24px;
    margin: 0;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .welcome-subtitle {
    font-size: 13px;
    margin: 0;
    opacity: 0.75;
  }
}

.stats-container {
  display: grid;
  grid-template-columns: repeat(5, minmax(160px, 1fr));
  gap: 18px;
  width: 100%;
  padding: 0;

  .stat-card {
    display: flex;
    align-items: center;
    padding: 18px 22px;
    border-radius: 10px;
    background: #f4f5fb;
    border: 1px solid #e2e5f0;
    justify-content: space-around;
    box-shadow: 0 14px 32px -28px rgba(31, 43, 77, 0.45);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 22px 38px -30px rgba(31, 43, 77, 0.4);
    }
  }

  .stat-icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    font-size: 28px;
    color: #fff;
    box-shadow: 0 16px 24px -18px rgba(31, 43, 77, 0.45);
  }

  .stat-meta {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
  }

  .stat-title {
    font-size: 14px;
    color: #7b86a6;
    font-weight: 500;
  }

  .stat-value {
    font-size: 34px;
    font-weight: 700;
    line-height: 1;
  }

  .is-total {
    .stat-value {
      color: #1a4dff;
    }
    .stat-icon {
      background: #1a4dff;
    }
  }

  .is-finished {
    .stat-value {
      color: #10b981;
    }
    .stat-icon {
      background: #10b981;
    }
  }

  .is-processing {
    .stat-value {
      color: #f59e0b;
    }
    .stat-icon {
      background: #f59e0b;
    }
  }

  .is-outbound {
    .stat-value {
      color: #1f8bff;
    }
    .stat-icon {
      background: #1f8bff;
    }
  }

  .is-inbound {
    .stat-value {
      color: #22c55e;
    }
    .stat-icon {
      background: #22c55e;
    }
  }
}
</style>
